import React from "react"
import Link from "gatsby-plugin-transition-link"
import cn from "classnames"
import * as s from "./round.module.scss"

type Props = {
  label: string
  href: string
  color?: "blue" | "white"
  disabled?: boolean
  external?: boolean
}

const Component: React.FC<Props> = ({
  label,
  href,
  color = "blue",
  disabled,
  external = false,
}) => {
  const regex = /^mailto\:/g
  const isMailto: boolean = href.match(regex)

  if (isMailto) {
    return external ? (
      <a
        href={href}
        target="_blank"
        className={cn(s.round, { [s[`color_${color}`]]: true })}
      >
        <span className={s.text}>{label}</span>
      </a>
    ) : (
      <a
        href={href}
        className={cn(s.round, { [s[`color_${color}`]]: true })}
      >
        <span className={s.text}>{label}</span>
      </a>
    )
  } else {
    return external ? (
      <a
        href={href}
        target="_blank"
        className={cn(s.round, { [s[`color_${color}`]]: true })}
      >
        <span className={s.text}>{label}</span>
      </a>
    ) : (
      <Link
        className={cn(s.round, { [s[`color_${color}`]]: true })}
        to={href}
        entry={{
          length: 1,
        }}
      >
        <span className={s.text}>{label}</span>
      </Link>
    )
  }
}

export default Component
